import type { ReactNode } from 'react';

export const symbol_view_day: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M149-160q-12 0-20.5-9t-8.5-21.5q0-12.5 8.63-21 8.62-8.5 21.37-8.5h661q12 0 20.5 9t8.5 21.5q0 12.5-8.62 21-8.63 8.5-21.38 8.5H149Zm0-580q-12 0-20.5-9t-8.5-21.5q0-12.5 8.63-21 8.62-8.5 21.37-8.5h661q12 0 20.5 9t8.5 21.5q0 12.5-8.62 21-8.63 8.5-21.38 8.5H149Zm31 409q-24.75 0-42.37-17.63Q120-366.25 120-391v-178q0-24.75 17.63-42.38Q155.25-629 180-629h600q24.75 0 42.38 17.62Q840-593.75 840-569v178q0 24.75-17.62 42.37Q804.75-331 780-331H180Zm0-60h600v-178H180v178Zm0-178v178-178Z"
		/>
	</svg>
);
